export default __webpack_public_path__ + "static/media/ic-plus-rounded.c419846b.svg";